/**
 * Instructions Section for Recipe Import Preview
 *
 * Displays instructions textarea for editing extracted recipe data.
 */

import type { ExtractedRecipe } from '@/types/recipeImport';

interface InstructionsSectionProps {
  recipe: ExtractedRecipe;
  onChange: (recipe: ExtractedRecipe) => void;
}

export function InstructionsSection({ recipe, onChange }: InstructionsSectionProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-gray-700">
        Cooking Steps
      </label>
      <p className="text-xs text-gray-400 mb-2">
        Enter each step on a new line. They will be numbered automatically.
      </p>
      <textarea
        value={recipe.instructions || ''}
        onChange={(e) => onChange({ ...recipe, instructions: e.target.value || null })}
        placeholder="1. First step...&#10;2. Second step...&#10;3. Third step..."
        rows={8}
        className="px-3.5 py-2.5 border border-gray-200 rounded-lg text-sm resize-y min-h-[200px] focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
      />
    </div>
  );
}
